












import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class HfSwitch extends Vue {
    @Prop({ type: String, default: "打开" })
    onText?: string;

    @Prop({ type: String, default: "关闭" })
    offText?: string;

    @Prop({ type: Boolean, default: false })
    model?: boolean;

    @Prop({ type: Number, default: 90 })
    width?: number;

    switchOn: boolean = true;

    mounted() {
        if (this.model != undefined) this.switchOn = this.model;
    }

    switchChange() {
        this.switchOn = !this.switchOn;
        this.$emit("update:model", this.switchOn);
        this.$emit("change", this.switchOn);
    }

    @Watch("model")
    modelChange(val: boolean) {
        this.switchOn = val;
    }
}
